"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGDPQuery = createGDPQuery;
exports.createParamsObject = createParamsObject;
exports.parseFiltersToGDP = parseFiltersToGDP;
var _constants = require("./../constants");
var _reducer = require("./reducer");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Create an object with the query params {search, qualifiers, sort, others}.
 *
 * @param {string} queryString : Query string with params.
 * @return {object} params : Object with params.
 */
function createParamsObject(queryString) {
  var _params;
  var params = (_params = {}, _defineProperty(_params, _constants.QUERY_PARAM_QUALIFIERS, {}), _defineProperty(_params, _constants.QUERY_PARAM_SEARCH, {}), _defineProperty(_params, _constants.QUERY_PARAM_SORT, {}), _defineProperty(_params, "others", {}), _params);
  if (!queryString) return params;
  var queryParams = {};
  queryString = queryString[0] === "?" ? queryString.substring(1) : queryString;
  var arrayParams = queryString.split("&");
  arrayParams.forEach(function (param) {
    var _param$split = param.split("="),
      _param$split2 = _slicedToArray(_param$split, 2),
      key = _param$split2[0],
      value = _param$split2[1];
    queryParams[key] = value;
  });
  Object.entries(queryParams).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    switch (key) {
      case _constants.QUERY_PARAM_SEARCH:
        params[_constants.QUERY_PARAM_SEARCH] = (0, _reducer.getParams)(value);
        break;
      case _constants.QUERY_PARAM_SORT:
        params[_constants.QUERY_PARAM_SORT] = (0, _reducer.getSortParams)(value);
        break;
      case _constants.QUERY_PARAM_QUALIFIERS:
        params[_constants.QUERY_PARAM_QUALIFIERS] = (0, _reducer.getParams)(value);
        break;
      default:
        params.others[key] = value;
        break;
    }
  });
  return params;
}

/**
 * Parse the filters of each param to the GDP format.
 *
 * @param {object} paramsObject : Object with the params {search, qualifiers, sort, others}.
 * @return {object} filtersParsed : Object with the same params received but with his value parsed.
 */
function parseFiltersToGDP(paramsObject) {
  var filtersParsed = {};
  for (var property in paramsObject) {
    var param = paramsObject[property];
    switch (property) {
      case _constants.QUERY_PARAM_SEARCH:
        filtersParsed[_constants.QUERY_PARAM_SEARCH] = (0, _reducer.parseParamsToGDP)(param);
        break;
      case _constants.QUERY_PARAM_SORT:
        filtersParsed[_constants.QUERY_PARAM_SORT] = (0, _reducer.parseSortOptionToGDP)(param);
        break;
      case _constants.QUERY_PARAM_QUALIFIERS:
        filtersParsed[_constants.QUERY_PARAM_QUALIFIERS] = (0, _reducer.parseParamsToGDP)(param);
        break;
      default:
        filtersParsed.others = (0, _reducer.parseOthersParamsToGDP)(param);
        break;
    }
  }
  return filtersParsed;
}

/**
 * Creates the GDP query required.
 *
 * @param {object} filtersParsed : Object with the params {search, qualifiers, sort, others}.
 * @return {string || null} String with GDP query format required.
 */
function createGDPQuery(filtersParsed) {
  var arrayGDPQueries = [];
  for (var param in filtersParsed) {
    filtersParsed[param].forEach(function (filtersObject) {
      Object.entries(filtersObject).forEach(function (filter) {
        arrayGDPQueries.push(filter.join("="));
      });
    });
  }
  arrayGDPQueries = _toConsumableArray(new Set(arrayGDPQueries));
  return arrayGDPQueries.sort().join("&") || null;
}